export default __webpack_public_path__ + "static/media/thumbs-up-full.84d3b6e4.svg";